import { useMemo } from "react"
import { rangeMaxValues } from "../const"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"

export function FiltersCount() {
    const filters = useFilterStore((s) => s)
    const count = useMemo(() => {
        let count = 0
        count += filters?.listing_status_in?.length || 0
        count += filters?.use_month_in?.length || 0
        count += filters?.origin_in?.length || 0
        count += filters?.resort?.short_name_in?.length || 0
        count += (filters.stars_gte || 1) > 1 ? 1 : 0
        if (filters.points_on_contract_gte || filters.points_on_contract_lte) {
            const from = filters.points_on_contract_gte
            const to = filters.points_on_contract_lte
            if (from > 20 || to < rangeMaxValues.points_on_contract) {
                count++
            }
        }
        if (filters.price_lte) {
            const to = filters.price_lte
            if (to <= rangeMaxValues.price) {
                count++
            }
        }
        if (filters.price_per_point_lte) {
            const to = filters.price_per_point_lte
            if (to <= rangeMaxValues.price_per_point) {
                count++
            }
        }
        return count
    }, [filters])
    const n = count ? `(${count})` : ""

    return `Filters` + n
}
